export class NewAuditRecordNotFoundError extends Error {
    constructor(...params) {
        // @ts-ignore
        super(...params)

        this.name = "NewAuditRecordNotFoundError"
    }
}
